import { Button, Group, Modal, Stack, Text, Textarea } from '@mantine/core'
import { useState } from 'react'
import { COLORS } from '../utils/constants'

interface RequestChangesModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (changes: string) => void
  isSubmitting: boolean
}

export function RequestChangesModal({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting,
}: RequestChangesModalProps) {
  const [changes, setChanges] = useState('')

  const handleConfirm = () => {
    if (!changes.trim()) return
    onConfirm(changes.trim())
    setChanges('')
  }

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title='Request Changes'
      centered
      size='md'
    >
      <Stack gap='xl'>
        <Text>
          Please provide details about the changes you would like to request for
          this design.
        </Text>
        <Textarea
          placeholder='Enter your requested changes...'
          value={changes}
          onChange={(event) => setChanges(event.currentTarget.value)}
          minRows={4}
          autosize
        />
        <Group justify='flex-end' gap='md'>
          <Button variant='subtle' onClick={onClose}>
            Cancel
          </Button>
          <Button
            color={COLORS.LightGreen}
            onClick={handleConfirm}
            loading={isSubmitting}
            disabled={!changes.trim()}
          >
            Submit Request
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
